export enum CognitoErrorTypes {
  UserLambdaValidation = 'UserLambdaValidationException',
  UserNotConfirmed = 'UserNotConfirmedException',
  UsernameExists = 'UsernameExistsException',
  UserNotFound = 'UserNotFoundException',
  NotAuthorized = 'NotAuthorizedException',
  NetworkError = 'NetworkError',
  LimitExceededException = 'LimitExceededException',
  ForceChangePassword = 'ForceChangePassword',
  MfaRequired = 'MfaRequired',
  UnknownChallenge = 'UnknownChallenge'
}

export enum CognitoErrorMessages {
  UserLambdaValidation = 'Your account failed verification. Contact support.',
  UserNotConfirmed = 'Your account is not confirmed. Please check your email for confirmation instructions.',
  UsernameExists = 'An account with this email already exists.',
  UserNotFound = 'We couldn’t find an account with this email.',
  NotAuthorized = 'Incorrect email or password.',
  NetworkError = 'A network error occurred. Please check your connection and try again.',
  LimitExceededException = 'Too many attempts. Please try again later.',
  ForceChangePassword = 'You need to set a new password before continuing.',
  MfaRequired = 'Multi-factor authentication is required to complete sign-in.',
  UnknownChallenge = 'Additional verification is required.',
  LoginAttemptsExceeded = 'Password attempts exceeded. Try again later or reset your password.'
}

export enum CognitoVerificationAttributes {
  Email = 'email',
  Phone = 'phone_number'
}

export enum CognitoUserAttributes {
  Email = 'email',
  EmailVerified = 'email_verified',
  FamilyName = 'family_name',
  Name = 'name',
  Phone = 'phone_number',
  PhoneNumberVerified = 'phone_number_verified',
  Sub = 'sub',
  TermAccepted = 'custom:termsAccepted'
}
